import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const VauxhallFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Vauxhall"
      slug="/lenders/mis-sold-vauxhall-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default VauxhallFinancePage
